<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="shopify"
      :logo="shopify"
      :success="success"
      :disconnected="disconnected"
      :warning="warning && !disconnected"
      :error="error"
      :logo-alt="$t('components.tileGroupConnectSales.shopifyLogo')"
      @click="openModal"
    />
    <!-- Shopify Modal -->
    <ModalShopify
      ref="shopifyModal"
      :reconnect-only="reconnectOnly"
      @hide="reconnectOnly = false"
      @submit="continueShopifyOauth"
      @error="$emit('error', SALES_PLATFORMS.SHOPIFY)"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
    />
  </span>
</template>

<script>
import { isMobileMixin, modalsRedirectMixin } from '@/utils/vue-mixins';
import { LocalStorage, LocalStorageKeys } from '@/utils/local-storage';
import { SALES_PLATFORMS } from '@/data/platforms';

import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';
import ModalShopify from '@/pages/connected-accounts/components/modals/ModalShopify.vue';

import shopifyIcon from '@/assets/logos/shopify.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalShopify,
  },
  mixins: [isMobileMixin, modalsRedirectMixin],
  props: {
    authorizeUri: {
      type: String,
      required: true,
    },
    success: Boolean,
    disconnected: Boolean,
    warning: Boolean,
    error: Boolean,
  },
  data() {
    return {
      storeName: '',
      reconnectOnly: false,
    };
  },
  computed: {
    shopify: () => shopifyIcon,
    SALES_PLATFORMS: () => SALES_PLATFORMS,
  },
  methods: {
    openModal() {
      this.clearOauthParams();
      // For Shopify app approval testing we need to be able to connect a native (non-fivetran) account
      // and show the checkmark but not have any further interactions, see SC-170954
      this.$emit('tileClick', SALES_PLATFORMS.SHOPIFY);
      this.$refs.shopifyModal.open();
    },
    continueShopifyOauth(storeName, connectionStatus) {
      this.storeName = storeName;
      // authorize URI provides link to the authorization page; www is replaced with store name for store's auth page.
      const authorizeUri = this.authorizeUri.replace('www', this.storeName);
      const options = { authorizeUri };
      options.noPopup = true;
      options.redirectRoute = this.redirectRoute;
      LocalStorage.setItem(
        LocalStorageKeys.OAUTH_PROVIDER,
        SALES_PLATFORMS.SHOPIFY,
      );
      LocalStorage.setItem(
        LocalStorageKeys.OAUTH_REDIRECT_ROUTE,
        this.redirectRoute,
      );
      LocalStorage.setItem(
        LocalStorageKeys.OAUTH_PREVIOUS_STATE,
        connectionStatus,
      );
      this.$emit('submit', options);
    },
    clearOauthParams() {
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_PROVIDER);
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_REDIRECT_ROUTE);
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_PREVIOUS_STATE);
    },
  },
  mounted() {
    if (this.$route.query?.reconnect === 'shopify') {
      this.reconnectOnly = true;
      this.openModal();
    }
  },
  beforeUnmount() {
    this.reconnectOnly = false;
  },
};
</script>
